module.exports = __webpack_public_path__ + "static/media/iata-logo-white.2ec514cd.png";